<template>
    <div id='news'>
        <!-- banner -->
        <img class='banner' src="../../assets/images/about/banner.png" alt="">

        <div class="type_area news">
            <!-- 内容盒子 -->
            <div class="content_box">
                <!-- 搜索 -->
                <div class="search">
                    <input type="text" placeholder="Search" v-model='value'>
                    <Icon type="ios-search" @click='search'/>
                </div>


                <!-- 内容 -->
                <div class="_content">

                    <div class="_alone" v-for='(item,index) in list' :key='index' v-loading>
                        <img :src="item.litpic" alt="">
                        <P>{{item.title}}</P>
                    </div>
                </div>

               
            </div>

<!--            &lt;!&ndash; 分页 &ndash;&gt;-->
<!--            <div class='page'>-->
<!--                <Page :total="50" @on-change='change' />-->
<!--            </div>-->
            
        </div>
    </div>
</template>



<script>
export default {
    data(){
        return{
            value:'',
        }
    },

    methods: {
        // 分页
        change(e){
            console.log('页码',e)
        },

        // 跳转到产品详情页面
        skip(e){
            this.$router.push({ path:'/details'+'?'+e})
        }
    },
    mounted() {
        this.id = this.$router.currentRoute.query.id;
        var search = this.$router.currentRoute.query.search;
        this.$http.get("http://dalong.test.abontest.com/api/search.php?id="+this.id+"&search="+search).then((res)=>{
            this.list = res.data.data;
        });
    },

}
</script>



<style scoped lang="less">
    #news{
        margin: 3rem 0 0;
        min-height: 45.5rem;
        .banner{
            width:100%;
        }

        // 新闻中心内容盒子
        .news{
            border:1px solid transparent;
        }

        // 内容盒子
        .content_box{
            margin-bottom: 2rem;

            // 搜索
            .search{
                margin: 1rem 0;
                input{
                    height: 2rem;
                    border: 1px solid #ccc;
                    outline: none;
                    border-radius: 1rem;
                    text-indent: 1rem;
                }
                i{
                    color:#257CE1;
                    font-size: 2rem;
                    position: absolute;
                    left: 12rem;
                    margin-top: 2px;
                }
            }
        }


        // 内容样式
        ._content{
            display:flex;
            flex-wrap: wrap;
            justify-content: space-between;
            ._alone{
                width:13rem;
                height:16rem;
                box-shadow:3px 3px 5px rgba(168, 168, 166, 0.849);
                margin-bottom: 1rem;
                display:flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                img{
                    width:100%;
                }
            }

            // 线
            .line{
                width:1px;
                height:100%;
                background:#ccc;
            }

            // 右
            .right{
                width:66%;
                height:100%;

                ._title{
                    overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
                    color:#257CE1;
                    text-align: center;
                }

                .text{
                    margin-top: 1rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    text-align: center;
                }
            }
        }

        // 分页
        .page{
            margin: 1rem 0;
            height:4rem;
            display:flex;
            justify-content: center;
        }
    }
</style>
